export default __webpack_public_path__ + "static/cs-email-automation--mobile-f765b0759b62ad30d38710839704a210.webp";